import { generateDefaultSelectors } from "@/redux/selectors.utils";
import { IState } from "@/redux/store.types";
import { getApiDataState } from "@/redux/utils";

import { $ShopNamesModuleName } from "./shopNames.types";

const { isLoading } = generateDefaultSelectors($ShopNamesModuleName);

const getShopNames = (state: IState) => {
    const shopNamesState = getApiDataState(state, $ShopNamesModuleName);
    return shopNamesState?.data || [];
};

export { getShopNames, isLoading };
